import React from 'react';
import Box from '@material-ui/core/Box';
import { RoundOverviewFixture } from './RoundOverviewModels';
import { Fixture } from '../TeamOverview/TeamOverviewModels';
import CreateRoundUtil from '../CreateRound/CreateRoundUtil';
import FixtureDialog from './FixtureDialog';

interface RofTitleProps {
  fixture: RoundOverviewFixture;
  editEnabled?: boolean;
  onChange?: (fixture? : Fixture) => void;
}

const RofTitle: React.FC<RofTitleProps> = (props) => {

  const onClose = (fixture? : Fixture) => {
    if (!fixture) {
      return;
    }
    props.fixture.name = fixture.name;
    props.fixture.fixture = fixture;
    if (props.onChange){
      props.onChange(fixture);
    }
  };
  var fixture = props.fixture;
  var fixtureName : any = fixture.name;
  if (props.editEnabled && fixture.fixture) {
    fixtureName = (<FixtureDialog open={false} fixture={fixture.fixture} draw={fixture.draw} extended={false} onClose={onClose} nameLinkEnabled={true} />)
  }

  return (
    <div>
      {fixtureName}
      <Box fontSize={11}>{CreateRoundUtil.toGameDateString(fixture.startingAt)} | {fixture.leagueName}</Box>
    </div>
  );
};
export default RofTitle;
